module.exports = __webpack_public_path__ + "img/6.0c0ec3d6.jpg";